export const AppRoutes = {
    configuracion: "/configuracion",
    configuracionCamposColaborador: "/configuracion/campos-colaborador",
    configuracionCamposQontactPoint: "/configuracion/campos-qontact-point",
} as const;
